import React from "react";
import { useWindAlarmColorBar } from "../CustomHooks";
import { getWindAlarmMetricLabel } from "../utility/windAlarmWindows";
import { CustomColorBar } from "./ColorBarComponent";
import { COLORBAR_GRADIENT } from "./colorbarConstants";
import "./colorBar.css";

const ColorBarWindAlarm = () => {
  const { isVisible, maxHoursWindAlarm, selectedMetric } =
    useWindAlarmColorBar();
  const subcategory = getWindAlarmMetricLabel(selectedMetric);

  return (
    <CustomColorBar
      gradient={COLORBAR_GRADIENT.WIND_RISK}
      category="Wind Alarm"
      subcategory={subcategory}
      unit="Hours"
      dataMin={0}
      dataMax={maxHoursWindAlarm > 0 ? maxHoursWindAlarm : 1}
      isVisible={isVisible}
    />
  );
};

export default ColorBarWindAlarm;
